<script>
import { mapActions, mapState } from "vuex";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

import dateMixin from "@/mixins/dateMixin";

import Loader from "@/components/_base/Loader";
import Stars from "@/components/_Shared/Professionals/Stars";
import Modal from "@/components/_Shared/Modal";

export default {
  mixins: [dateMixin],

  components: {
    Loader,
    Stars,
    swiper,
    swiperSlide,
    Modal
  },

  data() {
    return {
      swiperOption: {
        autoHeight: true,
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      feedbacks: [],
      loader: false,
      next: null,
      selectFeedback: null
    };
  },

  methods: {
    ...mapActions("orderScheduler", ["getFeedbacks"]),

    async setFeedbacks(payload) {
      try {
        this.loader = true;

        const response = await this.getFeedbacks(payload);

        this.feedbacks = [
          ...this.feedbacks,
          ...this.filterFeedbacksWithoutDescription(response.data)
        ];
        this.next = response.next;
      } catch (e) {
        this.next = null;
      }

      this.loader = false;
    },

    async nextPage() {
      if (!this.next) {
        return;
      }

      this.setFeedbacks({ next: this.next });
    },

    filterFeedbacksWithoutDescription(feedbacks) {
      return feedbacks.filter(
        feedback => feedback.description !== "Sem informação"
      );
    }
  },

  computed: {
    ...mapState("orderScheduler", ["professionalId"])
  },

  async mounted() {
    const payload = { professionalID: this.professionalId, page: 1 };
    await this.setFeedbacks(payload);
  }
};
</script>

<template>
  <div class="root" :class="{ 'root-loading': loader }">
    <swiper v-if="feedbacks.length" :options="swiperOption" @reachEnd="nextPage()">
      <swiper-slide v-for="feedback in feedbacks" :key="feedback.id">
        <div class="feedback" :class="{ 'loading': loader }">
          <div class="top">
            <Stars :rating="feedback.rating"/>

            <span class="feedback-date">{{ feedback.created_at | formatDate('MMM/YYYY') }}</span>
          </div>

          <small class="feedback-text" @click="selectFeedback = feedback">
            <span>
              "{{ feedback.description }}"
            </span>
          </small>
        </div>
      </swiper-slide>
      <div class="swiper-button-prev" slot="button-prev" @click.stop="">&#8249;</div>
      <div class="swiper-button-next" slot="button-next" @click.stop="">&#8250;</div>
      <div class="swiper-pagination"  slot="pagination"></div>
    </swiper>

    <div v-else-if="!loader" class="empty">
      Essa profissional ainda não recebeu uma avaliação por escrito.
    </div>

    <transition v-if="loader" name="fade" mode="in-out">
      <div class="loader" v-if="loader">
        <Loader />
        <p>Buscando avaliações do profissional...</p>
      </div>
    </transition>

    <modal v-if="selectFeedback" size="md" @close="selectFeedback = null">
      <template slot="header">
        <div class="top">
          <Stars :rating="selectFeedback.rating"/>

          <span class="feedback-date">{{ selectFeedback.created_at | formatDate('MMM/YYYY') }}</span>
        </div>
      </template>

      <template slot="body">
        <small class="feedback-fulltext">
          <span>
            "{{ selectFeedback.description }}"
          </span>
        </small>
      </template>

      <template slot="footer">
        <div class="btn bg-purple-outline" @click="selectFeedback = null">fechar</div>
      </template>
    </modal>
  </div>
</template>

<style scoped>
.root {
  padding: 16px 0;
  position: relative;
}

.root-loading {
  height: 170px;
}

.loader {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.loading {
  opacity: 0.25;
}

.feedback {
  max-width: 100%;
  width: 100%;
  max-height: 160px;
  overflow: hidden;
}

.top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
}

.feedback-text {
  margin-bottom: 24px;
  height: 100%;
  overflow: hidden;
  font-size: 14px;
  -webkit-line-clamp: 6;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  font-style: italic;
}

.feedback-date {
  font-size: 14px;
  color: #424242;
  font-weight: 400;
  opacity: 0.5;
}
.empty {
  text-align: center;
  font-size: 14px;
}

.swiper-button-next,
.swiper-button-prev {
  display: none;
}

.feedback-fulltext {
  text-align: center;
}

@media (min-width: 768px) {
  .swiper-button-next,
  .swiper-button-prev {
    display: block;
  }

  .feedback {
    max-width: 75%;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalList/Card/Feedbacks.vue